module.exports = __webpack_public_path__ + "static/why-d71548ce3ce02679ae593268686de401.gif";